import { render, staticRenderFns } from "./SignGestureImage.vue?vue&type=template&id=51e75c21&"
import script from "./SignGestureImage.vue?vue&type=script&lang=ts&"
export * from "./SignGestureImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports